import Application from '../Application';
import BakedModel from '../Utils/BakedModel';
export default class Decor {
    constructor() {
        this.application = new Application();
        this.scene = this.application.scene;
        this.resources = this.application.resources;
        this.bakeModel();
        this.setModel();
    }
    bakeModel() {
        this.bakedModel = new BakedModel(this.resources.items.gltfModel.environmentModelNew, this.resources.items.texture.computerSetupTexture, 3200);
    }
    setModel() {
        this.scene.add(this.bakedModel.getModel());
    }
}
